import Vue from 'vue';
import Vuex from 'vuex';
import app from "./modules/app";
import errorLog from "./modules/errorLog";
import permission from "./modules/permission";
import tagsView from "./modules/tagsView";
import settings from "./modules/settings";
import user from "./modules/user";
// 数据可视化
import vision from "./modules/vision";
import getters from "./getters";
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    errorLog: errorLog,
    permission: permission,
    tagsView: tagsView,
    settings: settings,
    user: user,
    vision: vision
  },
  getters: getters
});
export default store;